import { render, staticRenderFns } from "./StudentModality.vue?vue&type=template&id=27fd3ef3&"
import script from "./StudentModality.js?vue&type=script&lang=js&"
export * from "./StudentModality.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports